import { Box, Stack, Typography } from '@mui/material'
import NotificationIcon from '../../../assets/icons/plotTypes/NotificationIcon'

const EmptyNotificationView = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', py: 4 }}>
            <NotificationIcon />
            <Stack direction={'column'} alignItems={'center'}>
                <Typography variant={'body2'} component={'span'} align={'center'}>
                    No Notifications
                </Typography>
            </Stack>
        </Box>
    );
};

export default EmptyNotificationView;